import * as React from 'react';
import { Event } from '../calendar/calendar.event.types';

interface Props {
  event: Event;
}

interface States {

}

class EventbarComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);
  }

  render() {
    const { event } = this.props;
    return(
      <div style={{backgroundColor: event.backgroundColor}}>
        {event.title}
      </div>
    );
  }
}

export default EventbarComponent;



// WEBPACK FOOTER //
// ./src/dashboard/calendar.eventbar.component.tsx